import TabelaNoticia from './tabela-noticia'

export default TabelaNoticia
